import Sidemenu from '../components/base/sidemenu';
import Map from '../components/map/map';

export default function MapPage() {
    return (
        <div className='flex'>
            <Sidemenu />
            <Map />
        </div>
    );
}
